import { fetchWithDefaults } from '../config/fetchDefault';

const getPaymentMethods= async (agent)=>{
    try {
        const response = await fetchWithDefaults(`/subscription/paymentInfo?agent=${agent}`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}
const subscribeToProduct= async (product, agent, method, customer)=>{

    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({
                agent: agent,
                product:product,
                method:method,
                customer:customer
            })
        };

        const response = await fetchWithDefaults(`/subscription/subscribe`, requestOptions);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const jsonData = await response.json();
        if(jsonData.result){
            return jsonData.result
        }
        else{
            return false
        }
        //return jsonData;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

const getProductData = async () => {
    const stripeProductId = process.env.REACT_APP_FUNNEL_STRIPE_PRODUCT_ID

    try {
        const res = await fetchWithDefaults(`/lookupProduct?product=${stripeProductId}`)
        const data = await res.json()

        return data
    } catch (error) {
        console.error(error)
    }
}

export {
    getPaymentMethods,
    subscribeToProduct,
    getProductData
};